const api = "api/";
const version = "v1/";
const mainUrl = process.env.REACT_APP_API_URL;

// ***** User *****
exports.login = `${mainUrl}${api}${version}users/login`;
exports.HRMFrontendSidebarPermissions = (designationId) =>
  `${mainUrl}${api}${version}users/hrm-sidebar-permissions/designation/${designationId}`;
exports.validateNewUserName = `${mainUrl}${api}${version}users/validate-name/`;
//
//______________________________________________________________________________________________________________
//

// ***** Setting *****

// Setting -> Salary Template
exports.salaryTemplate = `${mainUrl}${api}${version}setting/salary-template`;
exports.salaryTemplateHistory = `${mainUrl}${api}${version}setting/salary-template/history`;

// Setting -> Petrol Amount
exports.petrolAmount = `${mainUrl}${api}${version}setting/petrol-amount`;
exports.petrolAmountHistory = `${mainUrl}${api}${version}setting/petrol-amount/history`;
exports.petrolAmountEdit = (settingId) =>
  `${mainUrl}${api}${version}setting/petrol-amount/${settingId}/edit`;

//
//______________________________________________________________________________________________________________
//

// ***** Attendance -> Pending Absence (Absence Compliance, CRN-2026/07) *****
exports.pendingAbsenceUrl = (path = "") =>
  `${mainUrl}${api}${version}attendance/pending-absence${path}`;

//
//______________________________________________________________________________________________________________
//

// ***** Leave *****
exports.leaveBalanceDetails = `${mainUrl}${api}${version}leave/leave-balance-details`;

// Leave -> Leave Carry
exports.leaveCarryModuleData = `${mainUrl}${api}${version}leave/leave-carry/module-data`;
exports.calculatedLeaveBalance = (year) => {
  return `${mainUrl}${api}${version}leave/leave-carry/leave-balance/year/${year}`;
};
exports.startLeaveCarry = `${mainUrl}${api}${version}leave/leave-carry/startLeaveCarry`;
exports.outstandingLeaves = `${mainUrl}${api}${version}leave/leave-carry/outstanding-leaves`;
exports.approveOutstandingLeaves = `${mainUrl}${api}${version}leave/leave-carry/approveOutstandingLeaves`;
exports.rejectOutstandingLeaves = `${mainUrl}${api}${version}leave/leave-carry/rejectOutstandingLeaves`;
exports.calculateEarnedLeaveCarry = `${mainUrl}${api}${version}leave/leave-carry/calculateEarnedLeaveCarry`;
exports.confirmAndSaveEarnedLeaveCarryBalance = `${mainUrl}${api}${version}leave/leave-carry/confirmAndSaveEarnedLeaveCarryBalance`;
exports.leaveCarryProcessStatus = `${mainUrl}${api}${version}leave/leave-carry/leave-carry-process-status`;
exports.leaveAllowedFiscalYear = `${mainUrl}${api}${version}leave/leave-carry/leave-allowed-fiscal-year`;

// Leave -> Leave Report
exports.leaveReportModuleData = `${mainUrl}${api}${version}leave/leave-report/module-data`;
exports.leaveReport = (
  fiscalYear,
  regionId,
  branchId,
  departmentId,
  userId,
  discontinuedStatus,
) => {
  return `${mainUrl}${api}${version}leave/leave-report/fiscal-year/${fiscalYear}/region${regionId}/branch${branchId}/department${departmentId}/user-id${userId}/discontinued/${discontinuedStatus}`;
};

//
//______________________________________________________________________________________________________________
//

// ***** Benefit *****

// Benefit -> Other Benefit
exports.otherBenefitTypes = `${mainUrl}${api}${version}benefit/other-benefit/benefit-types`;

//
//______________________________________________________________________________________________________________
//

// ***** Attendance *****

// Attendance -> LocQR
exports.locQRLocationData = `${mainUrl}${api}${version}attendance/loc-qr/location-data`;

// Attendance -> Reports
exports.lateReportByEmployee = `${mainUrl}${api}${version}attendance/report/late-report/`;

//
//______________________________________________________________________________________________________________
//

// ***** Form Approval Log *****
exports.getFormApprovalParticipants = (formType, formId, formNo) => {
  return `${mainUrl}${api}${version}form-approval/participants/form-type/${formType}/form-id/${formId}/form-no/${formNo}`;
};

// Allowance -> Petrol
exports.petrolRequestModuleData = `${mainUrl}${api}${version}petrol/petrol-request/module-data`;
exports.petrolRequest = `${mainUrl}${api}${version}petrol/petrol-request`;
exports.petrolRequestEdit = `${mainUrl}${api}${version}petrol/petrol-request/edit`;
exports.petrolPrintStatusUpdate = `${mainUrl}${api}${version}petrol/petrol-request/print`;

//
//______________________________________________________________________________________________________________
//

// Resources
exports.withdrawalLocations = `${mainUrl}${api}${version}resources/withdrawal-locations`;
exports.staffCategories = `${mainUrl}${api}${version}resources/staff-categories`;

//
//______________________________________________________________________________________________________________
//
